"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
var _validate = require("@/utils/validate");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UpdateStatementDialog',
  data: function data() {
    return {
      visible: false,
      importLoading: false,
      submitLoading: false,
      statement: {},
      excelFile: null,
      confirmInfo: null
    };
  },
  computed: {
    periodText: function periodText() {
      if (this.statement.periodDesc) return this.statement.periodDesc;
      if (this.statement.periodStart && this.statement.periodEnd) {
        return "".concat(this.statement.periodStart, " \u81F3 ").concat(this.statement.periodEnd);
      }
      return '-';
    },
    confirmInvalidOrderNos: function confirmInvalidOrderNos() {
      var invalidOrderNos = this.confirmInfo && this.confirmInfo.invalidOrderNos;
      return Array.isArray(invalidOrderNos) ? invalidOrderNos : [];
    }
  },
  created: function created() {
    this.debouncedSubmit = (0, _validate.Debounce)(this.handleSubmit, 500);
  },
  methods: {
    open: function open(row) {
      this.statement = _objectSpread({}, row);
      this.excelFile = null;
      this.confirmInfo = null;
      this.visible = true;
    },
    handleClosed: function handleClosed() {
      this.statement = {};
      this.excelFile = null;
      this.confirmInfo = null;
      this.importLoading = false;
      this.submitLoading = false;
    },
    beforeUpload: function beforeUpload(file) {
      var isExcel = /\.(xlsx|xls)$/i.test(file.name || '');
      if (!isExcel) {
        this.$message.warning('请导入 xls 或 xlsx 格式文件');
        return false;
      }
      return true;
    },
    handleImportRequest: function () {
      var _handleImportRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(options) {
        var file, formData, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = options.file;
              formData = new FormData();
              this.appendStatementParams(formData);
              formData.append('file', file);
              this.excelFile = file;
              this.confirmInfo = null;
              this.importLoading = true;
              _context.p = 1;
              _context.n = 2;
              return statementApi.statementUpdateImportApi(formData);
            case 2:
              data = _context.v;
              this.confirmInfo = data || {};
              this.$message.success('导入成功，请确认导入信息');
              if (options.onSuccess) options.onSuccess(data);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.excelFile = null;
              this.confirmInfo = null;
              if (options.onError) options.onError(_t);
            case 4:
              _context.p = 4;
              this.importLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function handleImportRequest(_x) {
        return _handleImportRequest.apply(this, arguments);
      }
      return handleImportRequest;
    }(),
    handleDownloadTemplate: function handleDownloadTemplate() {
      var url = 'https://admin.fucaiyijia.com/crmebimage/crmebimage/uploadf/excel/template/account_statement_update_template.xlsx';
      var link = document.createElement('a');
      link.href = url;
      link.download = 'account_statement_update_template.xlsx';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      if (!this.confirmInfo) {
        this.$message.warning('请先导入数据并确认导入信息');
        return;
      }
      if (!this.excelFile) {
        this.$message.warning('请重新导入 Excel 文件');
        return;
      }
      if (this.confirmInvalidOrderNos.length) {
        this.$message.error("\u5B58\u5728 ".concat(this.confirmInvalidOrderNos.length, " \u4E2A\u4E0D\u5C5E\u4E8E\u5F53\u524D\u5BF9\u8D26\u5355\u4E2D\u7684\u8BA2\u5355\uFF0C\u65E0\u6CD5\u66F4\u65B0\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u65B0\u5BFC\u5165"));
        return;
      }
      var formData = new FormData();
      this.appendStatementParams(formData);
      formData.append('file', this.excelFile);
      formData.append('fileName', this.excelFile.name);
      formData.append('confirmInfo', JSON.stringify(this.confirmInfo));
      formData.append('invalidOrderNos', JSON.stringify(this.confirmInvalidOrderNos));
      this.submitLoading = true;
      statementApi.statementUpdateConfirmApi(formData).then(function () {
        _this.$message.success('更新成功');
        _this.visible = false;
        _this.$emit('refresh');
      }).catch(function () {}).finally(function () {
        _this.submitLoading = false;
      });
    },
    merchantTypeText: function merchantTypeText(type) {
      var map = {
        1: '卡券供应商',
        2: '实物供应商',
        3: '家政供应商',
        4: '核销供应商'
      };
      return map[type] || '-';
    },
    formatConfirmValue: function formatConfirmValue(val) {
      return val !== '' && val !== null && val !== undefined ? val : '0';
    },
    getStatementParams: function getStatementParams() {
      return {
        statementId: this.statement.id,
        statementNo: this.statement.statementNo,
        merchantId: this.statement.merchantId,
        merchantType: this.statement.merchantType,
        periodStart: this.statement.periodStart,
        periodEnd: this.statement.periodEnd
      };
    },
    appendStatementParams: function appendStatementParams(formData) {
      var params = this.getStatementParams();
      Object.keys(params).forEach(function (key) {
        var value = params[key];
        if (value !== '' && value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });
    }
  }
};